export default __webpack_public_path__ + "static/media/Schedule.b32836de.svg";